import { Box } from '@mui/material';
import React from 'react';
import DynamicTabsComponent from '../../components/DynamicTabs/DynamicTabsComponent';
import EmployeeOffboarding from './EmployeeOffboarding';
import { useLocation } from 'react-router-dom';

function EmployeeOffboardingComponent() {
  const location = useLocation();
  const xyz = new URLSearchParams(location.search).get('xyz');
  const searchString = window.atob(xyz);

  const orgEmail = new URLSearchParams(searchString).get('orgEmail');
  const status = new URLSearchParams(searchString).get('status');

  const [activeTab, setActiveTab] = React.useState(() => {
    if (xyz && status) {
      if (status == 'APPROVED') return 1;
      if (status == 'REJECTED') return 2;
    } else {
      return 0;
    }
  });
  const [data, setData] = React.useState({
    status: status,
    orgEmail: orgEmail,
  });

  React.useEffect(() => {
    if (xyz && status) {
      setData({
        orgEmail: orgEmail,
        status: status,
      });
    }
    if (xyz && status) {
      if (status == 'APPROVED') {
        setActiveTab(1);
      }
      if (status == 'REJECTED') {
        setActiveTab(2);
      }
    } else {
      setActiveTab(0);
    }
  }, [location]);

  const clearProps = () => {
    setData({
      status: null,
      orgEmail: null,
    });
  };

  const [isEmp, setIsEmp] = React.useState(true);
  const options = [
    { value: 'PENDING', label: 'Employee List' },
    { value: 'APPROVED', label: 'Offboarded' },
    { value: 'REJECTED', label: 'Rejected' },
  ];
  const EmployeeOffboardingTab = [
    {
      title: 'Employee List',
      index: 0,
      component: (
        <EmployeeOffboarding
          selectedStatus={options[0]}
          orgEmailData={data}
          clearProps={clearProps}
        />
      ),
    },
    {
      title: 'Approved',
      index: 1,
      component: (
        <EmployeeOffboarding
          selectedStatus={options[1]}
          orgEmailData={data}
          clearProps={clearProps}
        />
      ),
    },
    {
      title: 'Rejected',
      index: 2,
      component: (
        <EmployeeOffboarding
          selectedStatus={options[2]}
          orgEmailData={data}
          clearProps={clearProps}
        />
      ),
    },
  ];
  return (
    <div>
      <Box className="main-content-overlay">
        <div className="main-content-div">
          <div>
            <DynamicTabsComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              TabsList={EmployeeOffboardingTab}
              isEmp={isEmp}
            />
          </div>
        </div>
      </Box>
    </div>
  );
}

export default EmployeeOffboardingComponent;
